import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const theme = window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
    document.documentElement.setAttribute("data-bs-theme", theme);
  }
}
